// Action Types

import {SET_PROVIDER_PROFILE_DATA, SET_CURRENT_STATE_DATA, SET_PNB_STRATEGY_DATA, SET_PNB_DOC_UPDATE_TYPE, ENABLE_SAVE_AND_EXIT, FETCH_PNB_HEADER_DATA, FETCH_PNB_HEADER_DATA_SUCCESS, SET_CURRENT_STATE_MODAL, SET_CURRENT_STATE_EDITABLE, SET_PROVIDER_PROFILE_EDITABLE, SET_PNB_STRATEGY_EDITABLE, SET_DOCUMENT_ID, REMOVE_TEMP_DATA, UPLOAD_TO_IMPACT_REQUEST, UPLOAD_TO_IMPACT_SUCCESS, UPLOAD_TO_IMPACT_FAILURE, UPLOAD_TO_IMPACT_RESET} from "../actionTypes";

//export const FETCH_USER_ACTION = 'FETCH_USER_ACTION';
export const FETCH_USER_ACTION_SUCCESS = 'FETCH_USER_ACTION_SUCCESS';
export const FETCH_USER_ACTION_FAIL= 'FETCH_USER_ACTION_FAIL';
export const FETCH_USER_DATA_REQUEST='FETCH_USER_DATA_REQUEST';
// Action Creators
export const fetchUserAction = (payload: any) => ({
    type: FETCH_USER_DATA_REQUEST,
    payload,
});

export const fetchUserActionSuccess = (payload: any) => ({
    type: FETCH_USER_ACTION_SUCCESS,
    payload,
});
export const fetchUserActionFail = (payload: any) => ({
    type: FETCH_USER_ACTION_FAIL,
    payload,
});

export const setProviderProfileData = (payload: any) => ({
    type: SET_PROVIDER_PROFILE_DATA,
    payload,
});
export const setCurrentStateData = (payload: any) => ({
    type: SET_CURRENT_STATE_DATA,
    payload,
});
export const setPnbStrategyData = (payload: any) => ({
    type: SET_PNB_STRATEGY_DATA,
    payload,
});
export const setDocumentId = (payload: string) => ({
    type: SET_DOCUMENT_ID,
    payload,
});
export const setUpdateType = (payload: any) => ({
    type: SET_PNB_DOC_UPDATE_TYPE,
    payload,
})
export const enableSaveAndExit = (payload: any) => ({
    type: ENABLE_SAVE_AND_EXIT,
    payload,
})

export const fetchPnbHeaderAction = (payload: any) => ({
    type: FETCH_PNB_HEADER_DATA,
    payload,
});
export const fetchPnbHeaderActionSuccess = (payload: any) => ({
    type: FETCH_PNB_HEADER_DATA_SUCCESS,
    payload,
});
export const setCurrentStateErrorModal = (showCurrentStateErrorModal: boolean) => ({
    type: SET_CURRENT_STATE_MODAL,
    payload: showCurrentStateErrorModal,
});
export const setCurrentStateEditable = (isEditableCurrentState: boolean) => ({
    type: SET_CURRENT_STATE_EDITABLE,
    payload: isEditableCurrentState,
});
export const setProviderProfileEditable = (isEditableProviderProfile: boolean) => ({
    type: SET_PROVIDER_PROFILE_EDITABLE,
    payload: isEditableProviderProfile,
});
export const setPnbStrategyEditable = (isEditablePnbStrategy: boolean) => ({
    type: SET_PNB_STRATEGY_EDITABLE,
    payload: isEditablePnbStrategy,
});
export const removeTempData = () => ({
    type: REMOVE_TEMP_DATA,
});

export const uploadToImpactRequest = (payload: any) => ({
    type: UPLOAD_TO_IMPACT_REQUEST,
    payload,
});
export const uploadToImpactSuccess = () => ({
    type: UPLOAD_TO_IMPACT_SUCCESS,
});
export const uploadToImpactFailure = () => ({
    type: UPLOAD_TO_IMPACT_FAILURE,
});
export const uploadToImpactReset = () => ({
    type: UPLOAD_TO_IMPACT_RESET,
});